
import React, {Component} from "react";
import {withTranslate} from 'react-redux-multilingual';

class NoMatch extends Component {
    render() {
        return (
            <section className="error_section">
                <p className="error_section_subtitle capitalized">{this.props.translate('page_not_found') + " " + "!"}</p>
                <h1 className="error_title">
                    <p>404</p>
                    404
                </h1>
                <a href="/" className="btn">{this.props.translate('go_home')}</a>
            </section>
        )
    };
}

export default withTranslate(NoMatch);

// import React, {Component} from "react"
// import {withTranslate} from 'react-redux-multilingual';
//
//
// class NoMatch extends Component {
//
//     state = {
//         height: 0,
//     }
//
//     componentWillMount() {
//         this.setState({
//             height: window.innerHeight,
//         });
//
//     }
//
//     componentDidMount() {
//
//
//         console.log(this.state.height)
//
//         document.getElementById("NoMatch").style.height = this.state.height + "px";
//     }
//
//     render() {
//         return (
//             <div className="NoMatch" id="NoMatch" style={{backgroundColor: '#446072', height: "100%", color: "#FFF"}}>
//                 {/*<section className="ftco-section doctors-list-all text-center">
//             <div className="container">
//                 <h3>Page <code>{location.pathname} Not found</code></h3>
//             </div>
//         </section>*/}
//
//
//                 <nav className="shelf">
//                     <a href="/" className="book home-page">{this.props.translate("home")}</a>
//                     <a href="/about" className="book about-us">{this.props.translate("about")}</a>
//                     <a href="/contact" className="book contact">{this.props.translate("contact")}</a>
//
//
//                     <span className="book not-found"></span>
//
//                     <span className="door left"></span>
//                     <span className="door right"></span>
//                 </nav>
//                 <h1 className="h1">{this.props.translate("404")}</h1>
//                 <p className="p">{this.props.translate("page_not_found")}</p>
//             </div>
//         )
//     }
// }
//
//
// export default withTranslate(NoMatch);